"use client";

import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ElCompromisoDeLaDraSoto() {
  const {
    ref: markerRef,
    isVisible: markerVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const {
    ref: headingRef,
    isVisible: headingVisible
  } = useRevealOnScroll<HTMLHeadingElement>({
    threshold: 0.2
  });
  const {
    ref: proseRef,
    isVisible: proseVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: metricsRef,
    isVisible: metricsVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: ctaRef,
    isVisible: ctaVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const {
    ref: imageRef,
    isVisible: imageVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const metrics = [{
    label: "AÑOS DE EXPERIENCIA",
    value: "+15"
  }, {
    label: "PACIENTES TRATADOS",
    value: "+10.000"
  }, {
    label: "cirugías",
    value: "+5000"
  }];
  return <section data-section-id="4269" id="el-compromiso-de-la-dra-soto" className="bg-background text-foreground overflow-hidden ![padding:160px_0px_160px_0px]">
      <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-16">
        <div className="flex flex-col lg:flex-row lg:items-center gap-12 lg:gap-[5%]">
          {}
          <div className="w-full lg:w-[45%] lg:-mt-10">
            <div ref={imageRef} className={`relative transition-all duration-[1400ms] ease-out ${imageVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
              {}
              <div className="relative p-2">
                <div className="absolute inset-0 border border-primary/60" aria-hidden="true" />
                <div className="relative overflow-hidden">
                  <div className="relative w-full" style={{
                  aspectRatio: "3 / 4"
                }}>
                    <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701322/img/dra_soto_consulta_clinica.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701322/img/dra_soto_consulta_clinica.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701322/img/dra_soto_consulta_clinica.png-wvc-sizes" alt="La Dra. María del Carmen Soto en consulta personalizada en MS Instituto Capilar" loading="lazy" decoding="async" className="absolute inset-0 object-cover !w-[500px] !h-[640px]" src="https://msinstitutocapilar.com/wp-content/uploads/2026/07/WhatsApp-Image-2026-06-27-at-10.50.26-1.jpeg" />
                  </div>
                </div>
              </div>
              <p className="mt-5 font-default italic text-sm md:text-[15px] text-muted-foreground/80 tracking-wide">
                Dra. María del Carmen Soto, Directora Médica.
              </p>
            </div>
          </div>

          {}
          <div className="w-full lg:w-[50%]">
            {}
            <div ref={markerRef} className={`transition-all duration-1000 ease-out ${markerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
              <p className="font-default text-xs uppercase tracking-[0.3em] text-primary !font-bold md:text-[13px]">NUESTRA FILOSOFÍA</p>
            </div>

            {}
            <h2 ref={headingRef} className="font-default font-medium text-foreground mt-8 leading-[1.05] tracking-tight transition-all duration-1000 delay-150 ease-out opacity-100 translate-y-0 !text-5xl">Resultados naturales, <em className="italic font-light text-foreground" data-ast-id="f:/src/pages/Home/sections/ElCompromisoDeLaDraSoto.tsx|sig:i9ujti" data-ast-start="3657" data-ast-end="3892" contenteditable="false">diseñados con precisión</em> médica</h2>

            {}
            <div ref={proseRef} className={`mt-12 space-y-6 transition-all duration-1000 delay-300 ease-out ${proseVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
              <p className="font-default text-[17px] leading-[1.7] text-foreground/85">En MS Instituto Capilar sabemos que recuperar tu cabello es mucho más que un tratamiento estético. La Dra. Soto analiza cada caso de forma individual, estudiando la singularidad de tu cuero cabelludo para diseñar un protocolo personalizado. Aplicamos técnicas de vanguardia mínimamente invasivas que priorizan la salud capilar y la naturalidad del resultado. Porque nuestro compromiso contigo es siempre honesto, humano y basado en la excelencia clínica.</p>
              
            </div>

            {}
            <Separator className="mt-14 bg-border" />

            {}
            <div ref={metricsRef} className={`mt-12 grid grid-cols-1 sm:grid-cols-3 gap-8 sm:gap-6 transition-all duration-1000 delay-[450ms] ease-out ${metricsVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
              {metrics.map((metric, i) => <div key={i} data-index={i} className="flex flex-col gap-2 sm:border-l sm:first:border-l-0 sm:border-border sm:pl-6 sm:first:pl-0">
                  <span className="font-default leading-none text-primary font-medium !text-4xl">
                    {metric.value}
                  </span>
                  <span className="font-default text-[11px] uppercase tracking-[0.25em] text-muted-foreground">
                    {metric.label}
                  </span>
                </div>)}
            </div>

            {}
            <div ref={ctaRef} className={`mt-14 transition-all duration-1000 delay-[600ms] ease-out ${ctaVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
              <Button asChild variant="ghost" className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md transition-all [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 aria-invalid:border-destructive has-[>svg]:px-3 group h-auto px-0 py-2 bg-transparent font-default text-[12px] uppercase tracking-[0.3em] text-foreground border-b border-foreground/40 inline-flex items-center gap-3 !font-bold disabled:pointer-events-none disabled:opacity-50 dark:aria-invalid:ring-destructive/40 dark:hover:bg-accent/50 hover:bg-transparent hover:text-primary hover:border-primary">
                <Link className="inline-flex items-center gap-3" href="https://msinstitutocapilar.com/dra-soto" newTab>
                  Conoce a la Dra. Soto
                  <ArrowRight className="size-4 transition-transform duration-500 group-hover:translate-x-1" />
                </Link>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>;
}